import User from "@Shared/Entities/AbstractEntities/User";
import constraints from "./constraints";
import migrate from "./migrate";
export default class PartnerUser extends User {
    constructor(data = {}) {
        super(migrate(data), constraints);
    }
    get type() {
        return this._data.type;
    }
    get partnerId() {
        return this._data.partnerId;
    }
    get baseUrl() {
        return `${super.baseUrl}/partners/${this.partnerId}/users/${this.id}`;
    }
    get data() {
        const parent = super.data;
        const { partnerId } = this;
        const { version } = this._data;
        return { ...parent, version, partnerId };
    }
    get links() {
        return {
            self: `${this.baseUrl}`,
        };
    }
}
